import { Trophy, Building2, ShoppingBag, Radio, Sparkles, GraduationCap, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const items = [
  { icon: Trophy, title: "Sports & Stadiums", text: "Center-hung jumbotrons, ribbon boards, and broadcast fascia engineered for live capture." },
  { icon: Radio, title: "Broadcast Studios", text: "Fine-pitch studio walls, virtual production volumes, and XR backdrops." },
  { icon: ShoppingBag, title: "Retail & Flagship", text: "Transparent storefront LED, mall canvases, and high-impact in-store activations." },
  { icon: Sparkles, title: "Live Events & Tours", text: "Touring LED rental, IMAG, and festival backdrops with on-site content ops." },
  { icon: Building2, title: "Corporate & Lobbies", text: "Boardroom video walls, digital signage, and immersive reception experiences." },
  { icon: GraduationCap, title: "Education & Civic", text: "Auditoriums, museums, transit hubs, and command-center display systems." },
];

export const Solutions = () => {
  return (
    <section id="solutions" data-testid="solutions-section" className="relative py-24 lg:py-32 bg-[#F7F6F2] border-y hairline">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl mb-16">
          <div className="eyebrow mb-4">Industries</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B1220] leading-[1.1]">
            Trusted across the environments where every pixel counts.
          </h2>
          <p className="mt-6 text-[#4B5563] text-base lg:text-lg leading-relaxed">
            From stadiums to storefronts, Smart Digi designs and deploys LED and LCD systems
            tuned to the room, the audience, and the content.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E7E5E0] border hairline rounded-2xl overflow-hidden">
          {items.map(({ icon: Icon, title, text }, i) => (
            <Reveal
              key={title}
              delay={i * 0.06}
              data-testid={`solution-card-${String(i + 1).padStart(2, "0")}`}
              className="group bg-white p-8 lg:p-10 hover:bg-[#FAFAF7] transition-colors"
            >
              <div className="w-11 h-11 rounded-lg bg-[#EAF0F8] flex items-center justify-center mb-6 group-hover:bg-[#00439C] transition-colors">
                <Icon size={20} className="text-[#00439C] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-display font-bold text-lg text-[#0B1220] mb-3">{title}</h3>
              <p className="text-[#4B5563] text-sm leading-relaxed mb-6">{text}</p>
              <div className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#00439C] group-hover:gap-2.5 transition-all">
                Learn more <ArrowRight size={13} />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
